// Shared helpers for the storefront bundle.
export const S = window.darat_store || { lang: "ar", currency: "ر.س" };
export const isAr = S.lang === "ar";
export const showPrices = !!S.showPrices;
export const $ = (sel, root = document) => root.querySelector(sel);
export const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
export const t = (ar, en) => (isAr ? ar : en);
export const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function esc(s) {
	return String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}

export function money(v) {
	const n = Number(v || 0);
	const txt = n.toLocaleString("en-US", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
	return isAr ? `${txt} ر.س` : `SAR ${txt}`;
}

export function icon(name, cls = "") {
	return `<svg class="di ${cls}" aria-hidden="true"><use href="#di-${name}"/></svg>`;
}

export function partArt(ic, label = "") {
	return `<div class="ds-art ds-art--${esc(ic || "generic")}" aria-hidden="true"><svg viewBox="0 0 160 120"><use href="#part-${esc(ic || "generic")}"/></svg>${label ? `<span class="ds-art__label" dir="ltr">${esc(label)}</span>` : ""}</div>`;
}

export async function api(method, args = {}, httpMethod = "GET") {
	const url = `/api/method/${method}`;
	const opts = { method: httpMethod, headers: { Accept: "application/json" }, credentials: "same-origin" };
	let full = url;
	if (httpMethod === "GET") {
		const qs = new URLSearchParams(Object.entries(args).filter(([, v]) => v !== undefined && v !== null && v !== ""));
		full = `${url}?${qs}`;
	} else {
		opts.headers["Content-Type"] = "application/json";
		if (window.frappe && frappe.csrf_token && frappe.csrf_token !== "{{ csrf_token }}") opts.headers["X-Frappe-CSRF-Token"] = frappe.csrf_token;
		opts.body = JSON.stringify(args);
	}
	const res = await fetch(full, opts);
	let data = {};
	try { data = await res.json(); } catch (e) { /* non-json */ }
	if (!res.ok || data.exc_type) {
		let msg = t("حدث خطأ، حاول مرة أخرى", "Something went wrong, please try again");
		if (res.status === 429) msg = t("محاولات كثيرة، حاول بعد قليل", "Too many requests, try again later");
		try {
			const sm = JSON.parse(data._server_messages || "[]");
			if (sm.length) msg = JSON.parse(sm[0]).message || msg;
		} catch (e) { /* ignore */ }
		const err = new Error(msg.replace(/<[^>]+>/g, ""));
		err.status = res.status;
		throw err;
	}
	return data.message;
}

export function store(key, value) {
	try {
		if (value === undefined) return JSON.parse(localStorage.getItem(key) || "null");
		localStorage.setItem(key, JSON.stringify(value));
	} catch (e) { return null; }
}

let toastTimer;
export function toast(html, ms = 3500) {
	const el = $("[data-toast]");
	if (!el) return;
	el.innerHTML = html;
	el.classList.add("is-on");
	clearTimeout(toastTimer);
	toastTimer = setTimeout(() => el.classList.remove("is-on"), ms);
}

export function cardHTML(i) {
	const name = isAr && i.a ? i.a : i.n;
	const low = S.lowStock || 3;
	let badges = i.bd ? `<span class="ds-badge">${esc(i.bd)}</span>` : "";
	if (i.q <= 0) badges += `<span class="ds-badge ds-badge--muted">${t("غير متوفر", "Out of stock")}</span>`;
	else if (i.q <= low) badges += `<span class="ds-badge ds-badge--warn">${t(i.q === 1 ? "آخر قطعة" : i.q === 2 ? "آخر قطعتين" : `آخر ${i.q} قطع`, `Only ${i.q} left`)}</span>`;
	const media = i.i ? `<img src="${esc(i.i)}" alt="${esc(name)}" loading="lazy" decoding="async">`
		: i.ri ? `<img class="is-rep" src="${esc(i.ri)}" alt="${esc(name)}" loading="lazy" decoding="async"><span class="ds-repnote">${t("صورة توضيحية", "Representative photo")}</span>`
		: partArt(i.ic, (i.m && i.m[0]) || "");
	return `<article class="ds-card" data-reveal data-code="${esc(i.c)}">
		<div class="ds-card__tools">
			<button type="button" class="ds-tool" data-wish="${esc(i.c)}" aria-label="${t("المفضلة", "Wishlist")}"><svg class="di" viewBox="0 0 24 24"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg></button>
			<button type="button" class="ds-tool" data-qv="${esc(i.c)}" aria-label="${t("عرض سريع", "Quick view")}">${icon("eye")}</button>
			<button type="button" class="ds-tool" data-cmp="${esc(i.c)}" aria-label="${t("مقارنة", "Compare")}"><svg class="di" viewBox="0 0 24 24"><path d="M8 4v16M16 4v16M4 8h8M12 16h8"/></svg></button>
		</div>
		<a class="ds-card__media" href="/p/${esc(i.u)}" aria-label="${esc(name)}">${media}${badges}</a>
		<div class="ds-card__body">
			<div class="ds-card__meta">${i.b ? `<span>${esc(i.b)}</span>` : ""}${i.gr ? `<span class="ds-grade ds-grade--${esc(i.gr)}" title="${esc(gradeHint(i.gr))}">${gradeLabel(i.gr)}</span>` : ""}<span dir="ltr">${esc(i.c)}</span></div>
			<h3 class="ds-card__title"><a href="/p/${esc(i.u)}">${esc(name)}</a></h3>
			${i.m && i.m.length ? `<div class="ds-card__pn" dir="ltr">${i.m.slice(0, 2).map((m) => `<span>${esc(m)}</span>`).join("")}</div>` : ""}
			<div class="ds-card__foot">${showPrices ? `<span class="ds-price">${money(i.p)}</span>` : "<span></span>"}
				<div class="ds-addwrap" data-addwrap="${esc(i.c)}"><button class="ds-btn ds-btn--icon ds-btn--primary" type="button" data-add="${esc(i.c)}" ${i.q <= 0 ? "disabled" : ""} aria-label="${t("أضف إلى السلة", "Add to cart")}">${icon("cart-plus")}</button></div></div>
			${i.pm ? `<p class="ds-card__match">${t("يطابق الرقم", "Matches part no.")} <b dir="ltr">${esc(i.pm)}</b></p>` : ""}
			${i.q > 0 ? `<p class="ds-card__pick">${icon("store")} ${t("استلام من المتجر بالرياض", "Pickup in Riyadh")}${i.wm ? `<span class="ds-card__wty">${icon("shield")} ${warrantyText(i.wm)}</span>` : ""}</p>` : `<p class="ds-card__pick is-out">${t("غير متوفر حالياً", "Out of stock")}</p>`}
		</div></article>`;
}

export const warrantyText = (m) => (isAr ? `ضمان ${m === 1 ? "شهر واحد" : m === 2 ? "شهرين" : m <= 10 ? `${m} أشهر` : `${m} شهراً`}` : `${m}-month warranty`);
export const gradeLabel = (g) => ({ original: t("أصلي", "Original"), hq: t("جودة عالية", "High quality"), oem: "OEM" }[g] || "");
export const gradeHint = (g) => ({ original: t("أصلية من الشركة المصنّعة للجهاز", "Made by the laptop's own brand"), oem: t("من نفس مصنع القطعة الأصلية، بدون شعار الماركة", "From the original part's factory, without the brand logo"), hq: t("بديل متوافق بجودة عالية وبنفس المواصفات", "High-quality compatible part with the same specs") }[g] || "");
export const SPEC_LABELS = {
	watt: t("القدرة", "Wattage"), volt: t("الجهد", "Voltage"), conn: t("نوع الرأس", "Connector"), size: t("مقاس الشاشة", "Screen size"),
	pins: t("عدد الأطراف", "Pins"), res: t("الدقة", "Resolution"), touch: t("شاشة لمس", "Touch"), cap: t("السعة", "Capacity"),
	ddr: t("الجيل", "Generation"), form: t("مخصصة لـ", "For"), speed: t("السرعة", "Speed"), kind: t("النوع", "Type"),
	wh: t("سعة البطارية", "Battery capacity"), cells: t("عدد الخلايا", "Cells"),
};
const SPEC_VALUES_AR = { Touch: "نعم", "Laptop (SODIMM)": "لابتوب (SODIMM)", "Desktop (UDIMM)": "كمبيوتر مكتبي (UDIMM)", External: "خارجي" };
export const specValue = (v) => (isAr ? SPEC_VALUES_AR[v] || String(v).replace(/^(\d+) cells$/, "$1 خلايا") : v);
